import axios, { AxiosInstance } from "axios";

const api: AxiosInstance = axios.create({
    baseURL: "/api",
    withCredentials: true,
});

//Custom redirect status code from back-end
api.interceptors.response.use((response) => {
    if (response.status === 278 && response.data.redirectUrl) {
        window.location.href = response.data.redirectUrl;
    }
    return response;
});

export default api;

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
}
